var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../../layouts/MainLayout';
import { storeCurrentMenuItemPosition, storeCurrentParentMenuItemPosition } from '../../../store/header/actions';
import { LoadingDefault } from '../../../components/common/loading/loading';
import { InputIcon } from '../../../components/common/input/input';
import { Pagination } from '../../../components/common/pagination/pagination';
import { formatNumber } from '../../../utils/CommonUtil';
import { getNetwork, resetNetworkInfo } from '../../../store/gam/actions';
import { networkData, isLoadNetwork } from '../../../store/gam/reducer';
import { getSynchronizeNetwork } from '../../../services/gam-service';
import _ from 'lodash';
import './index.scss';
import * as Constant from '../../../utils/Constant';
var TableDefault = Loadable({
    loader: function () { return import('../../../components/common/table/table'); },
    loading: function () { return React.createElement(LoadingDefault, null); },
    render: function (loaded, props) {
        var ComponentTable = loaded["TableDefault"];
        return React.createElement(ComponentTable, __assign({}, props));
    }
});
var Network = function (props) {
    var networksData = props.networksData, isLoadingNetworks = props.isLoadingNetworks;
    var history = useHistory();
    var t = useTranslation().t;
    var _a = useState([]), networkAll = _a[0], setNetworkAll = _a[1];
    var _b = useState([]), networkList = _b[0], setDataNetwork = _b[1];
    var _c = useState(""), keyword = _c[0], setKeyword = _c[1];
    var _d = useState(""), status = _d[0], setStatus = _d[1];
    var _e = useState([]), accountList = _e[0], setAccounts = _e[1];
    var _f = useState(""), accountSelected = _f[0], setAccountSelected = _f[1];
    var _g = useState({
        offset: 0,
        perPage: 30,
        currentPage: 0,
        pageCount: 5,
        pageSum: 30
    }), paging = _g[0], setPaging = _g[1];
    var _h = useState({
        isLoadingSync: false
    }), isLoadingDetail = _h[0], setLoadingDetail = _h[1];
    var _isMounted = useRef(true);
    var isLoadingSync = false;
    var columns = useMemo(function () { return [
        {
            Header: "#",
            accessor: "id",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "center" } }, row.value); }
        },
        {
            Header: "Pubdesk Account Name",
            accessor: "account.name",
        },
        {
            Header: "GAM Account Email",
            accessor: "account.accountEmail",
        },
        {
            Header: "GAM Network ID",
            accessor: "networkCode",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "center" } }, row.value); }
        },
        {
            Header: "" + t("gam.gam_network"),
            accessor: "displayName"
        },
        {
            Header: "" + t("gam.delivering_lineItems"),
            accessor: "totalLineItems",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "right" } }, typeof (row.value) == "number" && row.value > -1 ? formatNumber(row.value, 0) : "-"); }
        },
        {
            Header: "" + t("gam.connected_lineItems"),
            accessor: "connectedLineItems",
            Cell: function (row) { return React.createElement("div", { style: { textAlign: "right" } }, typeof (row.value) == "number" && row.value > -1 ? formatNumber(row.value, 0) : "-"); }
        }
    ]; }, [networkData]);
    useEffect(function () {
        document.title = t("page.network") + Constant.APP_NAME;
        props.dispatch(storeCurrentMenuItemPosition({ position: 3 }));
        props.dispatch(storeCurrentParentMenuItemPosition({ position: 0 }));
        getNetworkData();
        return function () {
            props.dispatch(resetNetworkInfo());
            _isMounted.current = false;
        };
    }, []);
    useEffect(function () {
        var networks = _.sortBy((networksData || []), function (option) { return option.id; });
        pepareAccountList(networks);
        handleGetData(networks || [], paging, status, keyword, accountSelected);
        setNetworkAll(networks);
    }, [networksData]);
    var getNetworkData = function () {
        props.dispatch(getNetwork({}));
    };
    var pepareAccountList = function (networks) {
        var accounts = [];
        networks.forEach(function (network) {
            if (network.account) {
                var foundAccount = (accounts || []).find(function (account) { return network.account.id == account.id; });
                if (!foundAccount) {
                    accounts.push(network.account);
                }
            }
        });
        accounts = (accounts || []).filter(function (item) { return item.enabled; });
        setAccounts(accounts);
    };
    var handleGetData = function (data, paging, status, keyword, accountSelected) {
        var dataNetwork = _.cloneDeep(data);
        var offset = paging.offset, perPage = paging.perPage, currentPage = paging.currentPage;
        var listNetwork = dataNetwork.filter(function (item) {
            return (!keyword ||
                (item.account.name || '').toLowerCase().indexOf((keyword || '').toLowerCase()) !== -1 ||
                (item.displayName || '').toLowerCase().indexOf((keyword || '').toLowerCase()) !== -1) &&
                //status
                (!status ||
                    (status == "CONNECTED" && item.connectedLineItems && item.connectedLineItems > 0) ||
                    (status == "NOT_CONNECTED" && (!item.connectedLineItems || (item.connectedLineItems && item.connectedLineItems < 0)))) &&
                (!accountSelected ||
                    (accountSelected && item.account.id == accountSelected));
        });
        var pageList = listNetwork.slice(offset, offset + perPage);
        paging.pageSum = listNetwork.length;
        paging.pageCount = Math.ceil(listNetwork.length / paging.perPage);
        setPaging(paging);
        setDataNetwork(pageList);
    };
    var onChangeSearch = function (event) {
        event.preventDefault();
        setKeyword(event.currentTarget.value);
        handleGetData(networkAll, paging, status, event.currentTarget.value, accountSelected);
    };
    var onChangeStatus = function (event) {
        event.preventDefault();
        setStatus(event.currentTarget.value);
        handleGetData(networkAll, paging, event.currentTarget.value, keyword, accountSelected);
    };
    var handlePageClick = function (e) {
        var selectedPage = e.selected;
        var perPage = paging.perPage;
        var offset = selectedPage * perPage;
        paging.currentPage = selectedPage;
        paging.offset = offset;
        setPaging(paging);
        handleGetData(networkAll, paging, status, keyword, accountSelected);
    };
    var handlePaperSelect = function (event) {
        var currentPage = paging.currentPage;
        paging.perPage = parseInt(event.currentTarget.value);
        var offset = currentPage * paging.perPage;
        paging.offset = offset;
        setPaging(paging);
        handleGetData(networkAll, paging, status, keyword, accountSelected);
    };
    var onChangeAccount = function (event) {
        event.preventDefault();
        setAccountSelected(event.currentTarget.value);
        handleGetData(networkAll, paging, status, keyword, event.currentTarget.value);
    };
    var onClickSynchronize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loadingData, param, result, loadingData, error_1, loadingData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingData = _.cloneDeep(isLoadingDetail);
                    loadingData.isLoadingSync = true;
                    setLoadingDetail(loadingData);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    param = {};
                    if (accountSelected) {
                        param.accountId = accountSelected;
                    }
                    return [4 /*yield*/, getSynchronizeNetwork(param)];
                case 2:
                    result = _a.sent();
                    handleGetData(result || [], paging, status, keyword, accountSelected);
                    loadingData = _.cloneDeep(isLoadingDetail);
                    loadingData.isLoadingSync = false;
                    setLoadingDetail(loadingData);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    loadingData = _.cloneDeep(isLoadingDetail);
                    loadingData.isLoadingSync = false;
                    setLoadingDetail(loadingData);
                    console.log("Synchronize Error");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content page-publishers" },
                        React.createElement("div", { className: "container-fluid container-alert" },
                            React.createElement("div", { className: "panel alert-list-container" },
                                React.createElement("div", { className: "panel-heading" },
                                    React.createElement(Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center", className: "" },
                                        React.createElement("div", null,
                                            React.createElement(InputIcon, { type: "text", value: keyword, onChange: onChangeSearch, iconName: "search", placeholder: t("gam.search_network_account") })),
                                        React.createElement("div", null,
                                            React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center", alignContent: "center", spacing: 1 },
                                                React.createElement(Grid, { item: true, className: "select-status filter-line-item" },
                                                    React.createElement("select", { className: "form-control btn", value: accountSelected, onChange: onChangeAccount },
                                                        React.createElement("option", { value: "" }, t("gam.filter_account")),
                                                        accountList && accountList.length ? accountList.map(function (account, index) { return React.createElement("option", { key: index, value: account.id }, account.name); }) : null)),
                                                React.createElement(Grid, { item: true, className: "select-status filter-line-item" },
                                                    React.createElement("select", { className: "form-control btn", value: status, onChange: onChangeStatus },
                                                        React.createElement("option", { value: "" }, "All"),
                                                        React.createElement("option", { value: "CONNECTED" }, "Connected"),
                                                        React.createElement("option", { value: "NOT_CONNECTED" }, "Not Connected"))),
                                                React.createElement(Grid, { item: true }),
                                                React.createElement(Grid, { item: true },
                                                    React.createElement(Button, { variant: "contained", color: "primary", onClick: onClickSynchronize, disabled: isLoadingDetail.isLoadingSync, style: { textTransform: "none" } }, t("gam.sync_btn"))))))),
                                React.createElement("div", { className: "panel-body" },
                                    React.createElement("div", { className: "table-container" },
                                        React.createElement(TableDefault, { columns: columns, data: networkList, loading: isLoadingNetworks || isLoadingDetail.isLoadingSync }))),
                                React.createElement("div", { className: "panel-footer" },
                                    React.createElement(Pagination, { handlePageClick: handlePageClick, pagePer: paging.perPage, pageCount: paging.pageCount, pageNumber: paging.currentPage, offset: paging.offset, pageSumLength: paging.pageSum, pageLength: networkList.length, handlePaperSelect: handlePaperSelect }))))))))));
};
function mapStateToProps(state) {
    return {
        networksData: networkData(state),
        isLoadingNetworks: isLoadNetwork(state)
    };
}
export default connect(mapStateToProps)(Network);
